import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { readAsOf } from '@/router/asOfQuery';

/*
 * Pages that only make sense for someone who can write, such as the report builder, do not exist
 * for read-only users or while the app shows a past date: the route sends them to its read-only
 * counterpart instead (`meta.writeFallback`), keeping the params and query.
 */

/**
 * Where a write-only route sends a user who cannot use it, or null to let them through.
 *
 * @param to - The route being entered
 * @param canWrite - Whether the user can write in the route's firm
 * @returns The redirect, or null
 */
export function writeRouteRedirect(to: Pick<RouteLocationNormalized, 'matched' | 'params' | 'query'>, canWrite: boolean): RouteLocationRaw | null {
  const record = [...to.matched].reverse().find((r) => r.meta.requiresWrite);
  if (!record)
    return null;

  if (canWrite && readAsOf(to.query) === null)
    return null;

  return { name: record.meta.writeFallback as string, params: to.params, query: to.query };
}
